import { BrowserRouter as Router, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import LandingPage from './LandingPage';
import ContactUsForm from './ContactUsForm';
import LoginForm from './LoginForm';
import TheVault from './TheVault';
import AboutUs from './AboutUs';
import AlphaModel from './AlphaModel';
import NavbarComponent from './Navbar';
import { logoutUser } from './AuthApi';
import { Button, Space, Typography, Dropdown, Avatar, Divider } from 'antd';
import { MenuOutlined, HomeOutlined, BankOutlined, InfoCircleOutlined, LogoutOutlined, UserOutlined } from '@ant-design/icons';
import './App.css';

const { Text } = Typography;

// AppContent component to use hooks inside Router context
const AppContent = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Set viewport meta tag for better mobile experience
  useEffect(() => {
    // Check if viewport meta tag exists
    let viewportMeta = document.querySelector('meta[name="viewport"]');
    
    // If it doesn't exist, create it
    if (!viewportMeta) {
      viewportMeta = document.createElement('meta');
      viewportMeta.name = 'viewport';
      document.head.appendChild(viewportMeta);
    }
    
    // Set appropriate content for mobile optimization
    viewportMeta.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0';
  }, []);

  return (
    <div className="App">
      <NavbarComponent />
      
      <main>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/contact-us" element={<ContactUsForm />} />
          <Route path="/clients" element={<LoginForm />} />
          <Route path="/vault" element={<TheVault />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/alpha-model" element={<AlphaModel />} />
        </Routes>
      </main>
    </div>
  );
};

// Main App component
function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;